import axiosClient from '../../api/axiosClient';

// TODO: Add client-side caching of conversation list

const conversationsModel = {
  state: {
    conversations: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    setConversations: (state, conversations) => {
      return { ...state, conversations };
    },
    setError(state, error) {
      return { ...state, error };
    },
    setIsLoading(state, isLoading) {
      return { ...state, isLoading };
    },
  },
  effects: dispatch => ({
    async getConversations() {
      try {
        dispatch.conversations.setIsLoading(true);
        const response = await axiosClient.get('/conversations');

        if (response.status === 200) {
          const conversations = response.data.data;
          dispatch.conversations.setConversations(conversations);
        } else {
          dispatch.conversations.setError(response.data.msg);
        }
      } catch (error) {
        dispatch.conversations.setError('An error occurred while fetching conversations');
        dispatch.toastModel.showToast({
          value: 'Danger',
          message: 'An error occurred while fetching conversations',
        });
      } finally {
        dispatch.conversations.setIsLoading(false);
      }
    },
  }),
};

export default conversationsModel;
